import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import './ProductService.scss'
import { Container } from "react-bootstrap"
import { AreaGuideDetails } from "../../../queries/common-use-query";
import HTMLReactParser from "html-react-parser";
import { Link } from "@StarberryUtils";

const ProductService = (props) => {
    // const address1 = props.address.address1;
    // const address2 = props.address.address2 ? props.address.address2 : "";
    // const address3 = props.address.address3 ? props.address.address3 : "";
    const { data, loading, error } = AreaGuideDetails(props.area);
    return (
        <section className="product-service area-guide-prop-detail" id="localarea">
            {(data && data.areaGuides.length > 0) && <Container>
                <div className="row justify-content-xxl-start justify-content-start">
                    <div className="col-xxl-5 col-xl-6 col-md-6">
                        <span className="sub-content">
                            local area
                        </span>
                        <ScrollAnimation animateIn='fadeInLeft'>
                            <div className="about-service w-100 p-0 m-0">
                                {data.areaGuides[0].Tile_Image && <div className="about-img area-guide-img" style={{ backgroundImage: `url(${data.areaGuides[0].Tile_Image.url})` }}>
                                    {/* <picture>
                                        <source media="(min-width:1200px)" srcSet={data.areaGuides[0].Tile_Image.url} />
                                        <source media="(min-width:768px)" srcSet={data.areaGuides[0].Tile_Image.url} />
                                        <img src={data.areaGuides[0].Tile_Image.url} alt={data.areaGuides[0].Tile_Image.alternativeText} />
                                    </picture> */}
                                </div>}
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div className="col-xxl-5 col-xl-6 col-md-6">
                        <ScrollAnimation animateIn='fadeInRight'>
                            <div className="service-description">
                                <h2>Spotlight on {data.areaGuides[0].Title}</h2>
                                {data.areaGuides[0].Intro_Content && HTMLReactParser(data.areaGuides[0].Intro_Content.replace(/\n/g, '<br />'))}
                                {data.areaGuides[0].URL && <Link to={`/about/local-living/${data.areaGuides[0].local_living.URL}/${data.areaGuides[0].URL}`} className="btn btn-primary mt-4">
                                    view area guide
                                </Link>}
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </Container>}
        </section>
    )
};
export default ProductService